Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _typeValidation = require('./typeValidation');

var _typeValidation2 = _interopRequireDefault(_typeValidation);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var PctyListDivider = function PctyListDivider(_ref) {
  var children = _ref.children,
      text = _ref.text,
      colSpan = _ref.colSpan,
      active = _ref.active,
      onClick = _ref.onClick,
      automationId = _ref.automationId,
      __TYPE = _ref.__TYPE,
      other = _objectWithoutProperties(_ref, ['children', 'text', 'colSpan', 'active', 'onClick', 'automationId', '__TYPE']);

  var otherProps = _extends({}, other, {
    className: ['pcty-item pcty-divider', active ? 'pcty-active' : '', other.className || ''].join(' ').trim(),
    'data-automation-id': automationId || null
  });

  var cellProps = { 'data-automation-id': automationId && automationId + '-label' || null };

  return _react2.default.createElement(
    'tr',
    _extends({}, otherProps, { onClick: onClick }),
    renderChildren(children),
    _react2.default.createElement(
      'td',
      _extends({ className: 'pcty-list-column', colSpan: colSpan }, cellProps),
      text
    )
  );
};

var renderChildren = function renderChildren(children) {
  return _react2.default.Children.map(children, function (child, i) {
    if (!child || !child.props || child.props.__TYPE === 'PctyListCheckboxColumn') {
      return _extends({}, child, {
        props: _extends({}, child.props, {
          key: 'pcty-list-divider-key-' + i
        })
      });
    }
  });
};

PctyListDivider.propTypes = {
  children: _propTypes2.default.node,
  /** If true, applies active styling to the item */
  active: _propTypes2.default.bool,
  /** Inserts text for divider  */
  text: _propTypes2.default.string.isRequired,
  /** Determines number of columns rendered in divider  */
  colSpan: _propTypes2.default.number,
  /** A handler function for the item click event */
  onClick: _propTypes2.default.func,
  /** A string that can be referenced by UI automation tools */
  automationId: _propTypes2.default.string,
  __TYPE: function __TYPE(props, propName, componentName) {
    return (0, _typeValidation2.default)(props, propName, componentName, 'PctyListDivider');
  }
  /** INCLUDE OTHER */
};

PctyListDivider.defaultProps = {
  active: false,
  colSpan: 1,
  onClick: function onClick() {},
  __TYPE: 'PctyListDivider'
};

exports.default = PctyListDivider;